import type { Dispatch, SetStateAction } from 'react';
import { MenuItem, FormGroup } from '@mui/material';
import { useTranslation } from '../../../contexts/TranslationContext';
import { MHMTypography } from '../MHM/MHMTypography';
import { MHMLabelledCheckbox } from '../MHM/MHMLabelledCheckbox';
import { MHMLabelledSelect } from '../MHM/MHMSelect';
import { MHMHyperlink } from '../MHM/MHMHyperlink';

// TODO: fix file formats that aren't working
// export const file_types = ['csv', 'excel', 'feather', 'html', 'json', 'latex', 'markdown', 'parquet', 'pickle', 'stata', 'xarray', 'xml'];
export const file_types = ['csv', 'xlsx', 'html', 'json', 'pickle'];

type DownloadCSVModalOptionsProps = {
  showRainfall: boolean;
  setShowRainfall: (show: boolean) => void;
  showWaterLevel: boolean;
  setShowWaterLevel: Dispatch<SetStateAction<boolean>>;
  showFilteredWaterLevel: boolean;
  setShowFilteredWaterLevel: Dispatch<SetStateAction<boolean>>;
  fileType: string;
  setFileType: (type: string) => void;
};

export function DownloadCSVModalOptions({
  showRainfall,
  setShowRainfall,
  showWaterLevel,
  setShowWaterLevel,
  showFilteredWaterLevel,
  setShowFilteredWaterLevel,
  fileType,
  setFileType,
}: DownloadCSVModalOptionsProps) {
  const { t } = useTranslation();

  return (
    <>
      <FormGroup>
        <MHMTypography fontStyle="italic">{t('Include:')}</MHMTypography>
        <MHMLabelledCheckbox
          checkboxProps={{
            checked: showWaterLevel,
            onChange: () => {
              setShowWaterLevel(checked => !checked);
            },
          }}
          label={
            <MHMTypography color="primary">
              {t('Water Level (Raw)')}
            </MHMTypography>
          }
        />
        <MHMLabelledCheckbox
          checkboxProps={{
            checked: showFilteredWaterLevel,
            onChange: () => {
              setShowFilteredWaterLevel(checked => !checked);
            },
          }}
          label={
            <MHMTypography color="primary">
              {t('Water Level (Filtered)')}
            </MHMTypography>
          }
        />
        <MHMLabelledCheckbox
          checkboxProps={{
            checked: showRainfall,
            onChange: event => setShowRainfall(event.target.checked),
            iconColor: 'rainfall',
          }}
          label={
            <MHMTypography color="rainfall">{t('Rainfall')}</MHMTypography>
          }
        />
      </FormGroup>
      <FormGroup sx={{ alignItems: 'end', justifyContent: 'start' }}>
        <MHMLabelledSelect
          selectProps={{
            value: fileType,
            onChange: event => setFileType(event.target.value as string),
          }}
          label={
            <MHMTypography sx={{ mr: 2 }}>{t('File Type:')}</MHMTypography>
          }
        >
          {file_types.map(file_type => (
            <MenuItem key={file_type} value={file_type}>
              {file_type}
            </MenuItem>
          ))}
        </MHMLabelledSelect>
        <MHMHyperlink
          href="https://mhmmanuals.ams3.cdn.digitaloceanspaces.com/ManholeMetrics%20Excel%20Graph%20Template%20V2.xlsx"
          target="_blank"
          sx={{ pt: 1 }}
        >
          {t('Download Excel Graph Template')}
        </MHMHyperlink>
      </FormGroup>
    </>
  );
}
